import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { festivalsService } from '../services/festivals.service'
import type { FestivalDocument } from '@/types'

interface UseFestivalsResult {
  festivals: Array<FestivalDocument & { id: string }>
  loading: boolean
  error: string | null
}

export function useFestivals(): UseFestivalsResult {
  const [festivals, setFestivals] = useState<Array<FestivalDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    festivalsService
      .getPublishedFestivals()
      .then(setFestivals)
      .catch((err: unknown) =>
        setError(formatUserFacingError(err, 'Failed to load festivals'))
      )
      .finally(() => setLoading(false))
  }, [])

  return { festivals, loading, error }
}
